import { render, staticRenderFns } from "./litigationInfo.vue?vue&type=template&id=2d9be293&scoped=true"
import script from "./litigationInfo.vue?vue&type=script&lang=js"
export * from "./litigationInfo.vue?vue&type=script&lang=js"
import style0 from "./litigationInfo.vue?vue&type=style&index=0&id=2d9be293&prod&lang=less&scoped=true"
import style1 from "./litigationInfo.vue?vue&type=style&index=1&id=2d9be293&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9be293",
  null
  
)

export default component.exports